<script>
import {onBeforeUnmount, onMounted, ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import $ from "jquery";

export default {
  name: "BillOfLadingPage",
  components: {LoadingPage},
  setup() {

    let loading = ref(false)
    let my_lading = ref([])

    function get_lading() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'show'}, 'my_barnameh', true).then((res) => {
        loading.value = false
        my_lading.value = res.data
      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_lading)
      })
    }
    get_lading()

    function delete_items(id) {

      Swals.Question('آیا از حذف این بارنامه اطمینان دارید؟', 'حذف' , 'red' , '#2F3A96').then((res)=>{
        if (res.isConfirmed){
          loading.value = true
          FreeWorld.Heisenberg({action:'delete' , bar_id:id}, 'my_barnameh', true).then((res) => {
            loading.value = false

            if (res.data.status === 'ok'){
              Swals.Done('بارنامه مورد نظر شما با موفقیت حذف شد')
              get_lading()
            }else {
              Swals.Warning('متاسفانه مشکلی پیش آمده است!')
            }

          }).catch((res) => {
            loading.value = false
            Swals.Catch(res, ()=>{delete_items(id)})
          })
        }
      })
    }

    let scroll = false

    onMounted(() => {
      scroll = true
    })
    onBeforeUnmount(() => {
      scroll = false
    })

    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY;
      // اگر کاربر به پایین اسکرول کرده باشد، کلاس hidden اضافه شود، در غیر این صورت حذف شود
      if (scroll) {
        scrollPosition > 100 ? $("#add_lading").removeClass('animate__fadeInUpBig').addClass('animate__fadeOutDownBig') : $("#add_lading").removeClass('animate__fadeOutDownBig').addClass('animate__fadeInUpBig')
      }
    });

    return {
      loading,
      my_lading,
      delete_items,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg"
           alt="">
      <p class="text-white font-bold font-4">بارنامه</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">

      <div v-if="my_lading.length === 0"
           class="animate__animated animate__fadeIn w-100 h-75 d-flex justify-content-center">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <img style="width: 10rem" src="../assets/img/icon-recruitment.svg" alt="" class="mb-4">
          <p class="font-4 text-center">در حال حاضر آیتمی وجود ندارد...!</p>
        </div>
      </div>

      <div v-else v-for="item in my_lading" :key="item.id"
           class="shadow-custom p-3 rounded-4 bg-custom position-relative mb-3 d-flex justify-content-between">

        <div class="d-flex flex-column justify-content-around">
          <p class="text-color font-4 font-bold mb-2">بارنامه با شماره {{ item.bar_number }}</p>
          <p class="text-color font-5 mb-2">{{ item.car_name }}</p>
          <p class="text-color font-5 mb-2">{{ item.bar_title }}</p>
          <p class="text-color font-5">تاریخ : {{ item.move_day }}</p>
        </div>

        <div class="d-flex flex-column justify-content-around w-25 me-3">
        <router-link :to="{name:'AddBillOfLading' , params:{type:'details', action:item.id}}" class="text-decoration-none py-2 px-4 text-center bg-color-light text-color shadow rounded-pill font-5">جزئیات</router-link>
        <router-link :to="{name:'AddBillOfLading' , params:{type:'edit', action:item.id}}" class="text-decoration-none py-2 my-3 px-4 text-center bg-yellow text-color shadow rounded-pill font-5">ویرایش</router-link>
        <p @click="delete_items(item.id)" class="text-decoration-none py-2 px-4 bg-danger text-color text-center shadow rounded-pill font-5">حذف</p>
        </div>
      </div>


      <router-link :to="{name:'AddBillOfLading' , params:{type:'add',action:'new'}}" id="add_lading"
                   class="animate__animated animate__fadeInUpBig position-fixed bottom-5 me-3">
        <img class="icon-size-6" src="../assets/img/icon-add.svg" alt="">
      </router-link>
    </div>
  </div>

</template>

<style scoped>

</style>